import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const INV_API = `${BACKEND_URL}/api/inv`;

export const LOCATION_TYPES = [
  { value: 'shop', label: 'Shop' },
  { value: 'van', label: 'Van' },
  { value: 'warehouse', label: 'Warehouse' },
  { value: 'trailer', label: 'Trailer' },
  { value: 'jobsite', label: 'Jobsite' },
  { value: 'temp', label: 'Temporary' },
  { value: 'other', label: 'Other' },
];

export const REASON_CODES = [
  'INITIAL', 'PURCHASED', 'RESTOCK', 'VAN_COUNT', 'USED_ON_JOB', 'RETURNED_TO_SHOP', 'TRANSFER',
  'STOCK_CORRECTION', 'DAMAGED', 'LOST', 'ADJUSTMENT', 'OTHER',
];

// Friendly labels for the manual adjustment dialog (maps canonical code → wording).
export const REASON_LABELS = {
  INITIAL: 'Initial Loadout',
  RESTOCK: 'Restock',
  VAN_COUNT: 'Van Count',
  STOCK_CORRECTION: 'Inventory Correction',
  DAMAGED: 'Damaged',
  LOST: 'Lost',
  RETURNED_TO_SHOP: 'Returned to Shop',
  PURCHASED: 'Purchased / Received',
  USED_ON_JOB: 'Used on Job',
  TRANSFER: 'Transfer',
  ADJUSTMENT: 'Adjustment',
  OTHER: 'Other',
};

// Reasons offered in the manual adjustment dialog (the operational subset).
export const ADJUST_REASONS = ['INITIAL', 'RESTOCK', 'VAN_COUNT', 'STOCK_CORRECTION', 'DAMAGED', 'LOST', 'RETURNED_TO_SHOP', 'OTHER'];

export const PRIORITIES = ['low', 'normal', 'high', 'urgent'];

// Shared axios helper with credentials
export const inv = {
  get: (path, params) => axios.get(`${INV_API}${path}`, { withCredentials: true, params }),
  post: (path, body) => axios.post(`${INV_API}${path}`, body, { withCredentials: true }),
  put: (path, body) => axios.put(`${INV_API}${path}`, body, { withCredentials: true }),
  patch: (path, body) => axios.patch(`${INV_API}${path}`, body || {}, { withCredentials: true }),
  delete: (path) => axios.delete(`${INV_API}${path}`, { withCredentials: true }),
};
